import { render, staticRenderFns } from "./Practices.vue?vue&type=template&id=4a52ab39&"
import script from "./Practices.vue?vue&type=script&lang=js&"
export * from "./Practices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports